import { Gateway } from '@ad-lucy/gateway-provider';
import type { GatewayKeycloak } from '@ad-lucy/gateway-provider/keycloak';
import translation from '@ad-lucy/translation';
// Import Inter font styles used by @ad-lucy/ui components
import '@ad-lucy/ui/lib/assets/fonts/inter/inter.css';
import { i18nBoot, i18nRegisterLocale } from '@i18n/i18n.utils';
import { getAppConfig } from '@modules/config/appConfig';
import App from '@modules/containers/App';
import reactDom from 'react-dom/client';

if ('Cypress' in globalThis) {
  // @ts-expect-error - exposed for tests
  globalThis.i18n = translation.i18n;
}

export function renderApp(keycloak: GatewayKeycloak) {
  // app config has not been validated at this point, so we need to be defensive
  const { API_ROOT, APOLLO_CLIENT_DEV_TOOLS, ORG_ID, SUPPORTED_LANGUAGES } =
    getAppConfig() ?? {};

  i18nBoot({
    supportedLngs: SUPPORTED_LANGUAGES,
  }).then(() => {
    i18nRegisterLocale();
  });

  const gateway = new Gateway({
    keycloakAdapter: keycloak,
    gatewayOptions: {
      uri: API_ROOT,
      orgId: ORG_ID,
    },
    apolloClientOptions: {
      connectToDevTools: APOLLO_CLIENT_DEV_TOOLS,
    },
  });

  const rootNode = document.getElementById('root');

  if (!rootNode) {
    throw new Error('Element with id "root" not found in the DOM');
  }

  reactDom
    .createRoot(rootNode)
    .render(<App gateway={gateway} keycloak={keycloak} />);
}
